import { searchCompany, ZefixCompany } from "./ZefixAPI";
import { SelectChooser } from "../components/select/SelectChooser";
import React from "react";
import Button from "../components/Button";
import { useI18n } from "../hooks/i18n-hooks";
import Callout from "../ui_atoms/Callout";

export type ZefixChooserProps = {
    onSelect: (zefixCompany: ZefixCompany) => void;
    onDismiss: () => void;
    isVisible: boolean;
    language?: string;
    placeholder?: string;
};

export const ZefixChooser: React.FC<ZefixChooserProps> = ({
    onSelect,
    onDismiss,
    isVisible,
    placeholder,
    language = "en",
}) => {
    const i18n = useI18n();
    const searchContact = React.useCallback(
        async (filter: string) => {
            if (!filter || filter.length < 3) {
                return [];
            }
            const ret = await searchCompany(filter, language);
            return ret.map((c) => ({
                value: c,
                label: c.name,
                description: c.legalSeat,
            }));
        },
        [language],
    );
    return (
        <SelectChooser<ZefixCompany>
            isDynamicHeight={true}
            visible={isVisible}
            onDismiss={onDismiss}
            searchItems={searchContact}
            emptyResult={<Callout mode="warning" markdown={i18n.t("no_result")} />}
            onSelect={(i) => {
                onSelect?.(i.value);
            }}
            placeholder={placeholder}
            selectable={false}
        />
    );
};

type ZefixChooserButtonProps = {
    onSelect?: (zefixCompany: ZefixCompany) => void;
    buttonLabel?: string;
    placeholder?: string;
    language?: string;
};

const ZefixChooserButton: React.FC<ZefixChooserButtonProps> = ({
    onSelect,
    buttonLabel,
    placeholder,
    language = "en",
}) => {
    const [isVisible, setIsVisible] = React.useState(false);

    return (
        <>
            <Button onPress={() => setIsVisible(true)} label={buttonLabel || ""} />
            <ZefixChooser
                isVisible={isVisible}
                onDismiss={() => setIsVisible(false)}
                onSelect={(i) => {
                    setIsVisible(false);
                    onSelect?.(i);
                }}
                placeholder={placeholder}
                language={language}
            />
        </>
    );
};

export default ZefixChooserButton;
